import { useEffect, useState } from 'react';

// Desktop breakpoint - adjust this value based on your design requirements
const DESKTOP_BREAKPOINT = 970; // pixels

export const useDesktopMode = () => {
  const [isDesktopMode, setIsDesktopMode] = useState<boolean>(false);

  useEffect(() => {
    // Function to check if current screen size is desktop
    const checkIsDesktop = () => {
      return window.innerWidth >= DESKTOP_BREAKPOINT;
    };

    // Set initial value
    setIsDesktopMode(checkIsDesktop());

    // Create resize handler
    const handleResize = () => {
      setIsDesktopMode(checkIsDesktop());
    };

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isDesktopMode;
};
